export const appTranslations = {
  en: () => import('./en.json').then(translations => ({ en: translations.default })),
  de: () => import('./de.json').then(translations => ({ de: translations.default })),
  fr: () => import('./fr.json').then(translations => ({ fr: translations.default })),
  nl: () => import('./nl.json').then(translations => ({ nl: translations.default })),
  sv: () => import('./sv.json').then(translations => ({ sv: translations.default })),
  fi: () => import('./fi.json').then(translations => ({ fi: translations.default })),
};

export const rtiTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "ng-locale-en" */
      '@recruitee/integrations/locales/en.json'
    ).then(translations => ({
      en: translations.default,
    })),
  de: () =>
    import(
      /* webpackChunkName: "ng-locale-de" */
      '@recruitee/integrations/locales/de.json'
    ).then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import(
      /* webpackChunkName: "ng-locale-fr" */
      '@recruitee/integrations/locales/fr.json'
    ).then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import(
      /* webpackChunkName: "ng-locale-nl" */
      '@recruitee/integrations/locales/nl.json'
    ).then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import(
      /* webpackChunkName: "ng-locale-sv" */
      '@recruitee/integrations/locales/sv.json'
    ).then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import(
      /* webpackChunkName: "ng-locale-fi" */
      '@recruitee/integrations/locales/fi.json'
    ).then(translations => ({
      fi: translations.default,
    })),
};

export const uiTranslations = {
  en: () =>
    import(/* webpackPrefetch: true */ '@recruitee/user-interface/locales/en.json').then(
      translations => ({
        en: translations.default,
      }),
    ),
  de: () =>
    import('@recruitee/user-interface/locales/de.json').then(translations => ({
      de: translations.default,
    })),
  fr: () =>
    import('@recruitee/user-interface/locales/fr.json').then(translations => ({
      fr: translations.default,
    })),
  nl: () =>
    import('@recruitee/user-interface/locales/nl.json').then(translations => ({
      nl: translations.default,
    })),
  sv: () =>
    import('@recruitee/user-interface/locales/sv.json').then(translations => ({
      sv: translations.default,
    })),
  fi: () =>
    import('@recruitee/user-interface/locales/fi.json').then(translations => ({
      fi: translations.default,
    })),
};

export const wysiwygTranslations = {
  en: () =>
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "ng-locale-en" */
      '@recruitee/prosemirror/locales/src/en.json'
    ).then(t => ({ en: t.default })),
  de: () =>
    import(
      /* webpackChunkName: "ng-locale-de" */
      '@recruitee/prosemirror/locales/src/de.json'
    ).then(t => ({ de: t.default })),
  fr: () =>
    import(
      /* webpackChunkName: "ng-locale-fr" */
      '@recruitee/prosemirror/locales/src/fr.json'
    ).then(t => ({ fr: t.default })),
  nl: () =>
    import(
      /* webpackChunkName: "ng-locale-nl" */
      '@recruitee/prosemirror/locales/src/nl.json'
    ).then(t => ({ nl: t.default })),
  sv: () =>
    import(
      /* webpackChunkName: "ng-locale-sv" */
      '@recruitee/prosemirror/locales/src/sv.json'
    ).then(t => ({ sv: t.default })),
  fi: () =>
    import(
      /* webpackChunkName: "ng-locale-fi" */
      '@recruitee/prosemirror/locales/src/fi.json'
    ).then(t => ({ fi: t.default })),
};
